module.exports = __webpack_public_path__ + "img/icon-pdf.64170880.svg";